export const MFA_SIGN_IN_STATUS = {
  NEEDS_SECOND_FACTOR: 'needs_second_factor',
  COMPLETE: 'complete',
  NEEDS_CLIENT_TRUST: 'needs_client_trust',
} as const;

export const TOTP_CODE_LENGTH = 6;
